import React from 'react';
import SpayImages from './spayimages';
import { Link } from 'react-router-dom';
import $ from 'jquery';

class SpayFooter extends React.Component {
    componentDidMount() {
        $('.s-footer-nav__container--mobile .s-footer-nav__list-wrap li').click(function () {
            var $el = $('ul', this);
            $('ul ul').not($el).slideUp();
            $(this).find('ul').slideToggle();
        });
    }

    handleScrollToTop = () => {
        let timer = setTimeout(() => {
            window.scrollTo(0, 0);
        }, 1000);

        return () => clearTimeout(timer);
    };

    render() {
        const { SpayArrow, SpayFacebook_icon, SpayTwitter_icon, SpayInstagram_icon, SpayLinkedin_icon } = SpayImages();

        return (
            // Footer Content | Start Here

            <footer className="s-footer">
                {/*This Section is solved */}
                <div className="s-signup">
                    <div className="s-signup__card">
                        <div className="s-signup__content">
                            <h3 className="s-signup__title">Get started now to grow your business.</h3>
                            <form className="s-signup__form">
                                <div className="s-signup__email mobile tablet desktop">
                                    <div className="s-signup__email-icon"></div>
                                    <input
                                        className="s-signup__email-input"
                                        type="email"
                                        placeholder="Enter your email address"
                                    />
                                </div>

                                <div className="s-signup__register mobile tablet desktop">
                                    <button className="s-signup__btn">Create Account</button>
                                    <p className="s-signup__paragraph">Let's create an account for you!</p>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>

                <div className="[ s-footer-block ]">
                    {/*This Section is solved */}
                    <div className="[ s-footer-block__support-wrap ]">
                        <div className="[ s-footer-block__support ]">
                            <div className="s-footer-block__support-headercontainer">
                                <h4 className="[ s-footer-block__support-header ]">Contact</h4>
                                <div className="[ s-footer-block__support-header-border ]"></div>
                            </div>
                            <div className="s-footer-block__support-secondcontainer">
                                <div className="[ s-footer-block__support-col  s-footer-block__support-col--mod ] sect-1 ">
                                    <ul className="[ s-footer-block__support-list-wrap ]">
                                        <li className="[ s-footer-block__support-list ]">
                                            +234 700 123 SPAY
                                            <br /> <br /> +234 913 700 0041
                                        </li>
                                    </ul>
                                </div>

                                <div className="[ s-footer-block__support-col  s-footer-block__support-col--mod ] sect-2">
                                    {/*<h4 className="[ s-footer-block__support-header ]">addresses</h4>*/}
                                    {/*<div className="[ s-footer-block__support-header-border ]"></div>*/}
                                    <ul className="[ s-footer-block__support-list-wrap ]">
                                        <li className="[ s-footer-block__support-list ]">
                                            <h3>Lagos</h3>
                                            6 Mojidi Street, Off Toyin Street,
                                            <br /> Ikeja, <br /> Lagos, Nigeria.
                                        </li>
                                        <br />
                                        <br />
                                        {/* <li className="[ s-footer-block__support-list ]">
                                            <h3>Delaware</h3> 16192 Coastal Highway Lewes <br /> DE 19958, County of
                                            Sussex, <br /> United States of America.
                                        </li> */}
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/*I'm currently working on this */}
                    <div className="[ s-footer-nav ]">
                        <div className="[ s-footer-nav__resizer ]">
                            {/*Mobile Navigation Structure | Start Here */}

                            <nav className="s-footer-nav__container  s-footer-nav__container--mobile">
                                <ul className="s-footer-nav__list-wrap  s-footer-nav__list-wrap--mod">
                                    <li className="s-footer-nav__list">
                                        <Link
                                            className="s-footer-nav__list-item"
                                            to="/"
                                            onClick={() => {
                                                this.handleScrollToTop();
                                            }}>
                                            why spay
                                        </Link>
                                    </li>
                                    <li className="s-footer-nav__list" onClick={() => this.handleScrollToTop()}>
                                        <Link className="s-footer-nav__list-item" to="/Spay-Pricing">
                                            pricing
                                        </Link>
                                    </li>
                                    <li className="s-footer-nav__list" onClick={() => this.handleScrollToTop()}>
                                        <Link className="s-footer-nav__list-item" to="/">
                                            customers
                                        </Link>
                                    </li>
                                </ul>

                                <ul className="s-footer-nav__list-wrap  s-footer-nav__list-wrap--mod">
                                    <li className="s-footer-nav__list">
                                        <Link to="/" className="s-footer-nav__list-item  pointerDisabled">
                                            developers
                                            <span>
                                                <img
                                                    className="s-footer-nav__list-icon"
                                                    src={SpayArrow}
                                                    alt="arrow-btn"
                                                />
                                            </span>
                                        </Link>
                                        <ul className="s-footer-nav__submenu  s-footer-nav__submenu--mod">
                                            <li className="s-footer-nav__submenu-list">
                                                <a
                                                    href="https://spay.readme.io/docs"
                                                    className="s-footer-nav__submenu-list-item">
                                                    Documentation
                                                </a>
                                            </li>
                                            <li
                                                className="s-footer-nav__submenu-list"
                                                onClick={() => this.handleScrollToTop()}>
                                                <Link className="s-footer-nav__submenu-list-item" to="/">
                                                    Status Page
                                                </Link>
                                            </li>
                                        </ul>
                                    </li>

                                    <li className="s-footer-nav__list">
                                        <Link to="/" className="s-footer-nav__list-item pointerDisabled">
                                            support
                                            <span>
                                                <img
                                                    className="s-footer-nav__list-icon"
                                                    src={SpayArrow}
                                                    alt="arrow-btn"
                                                />
                                            </span>
                                        </Link>
                                        <ul className="s-footer-nav__submenu  s-footer-nav__submenu--mod">
                                            <li
                                                className="s-footer-nav__submenu-list"
                                                onClick={() => this.handleScrollToTop()}>
                                                <Link className="s-footer-nav__submenu-list-item" to="/spay-help">
                                                    SPay Help
                                                </Link>
                                            </li>
                                            <li className="s-footer-nav__submenu-list">
                                                <a
                                                    className="s-footer-nav__submenu-list-item"
                                                    href="/terms-and-conditions">
                                                    Terms & Conditions
                                                </a>
                                            </li>
                                            {/* <li className="s-footer-nav__submenu-list">
                                                <Link className="s-footer-nav__submenu-list-item" to="/">
                                                    Community
                                                </Link>
                                            </li> */}
                                            <li
                                                className="s-footer-nav__submenu-list"
                                                onClick={() => this.handleScrollToTop()}>
                                                <Link className="s-footer-nav__submenu-list-item" to="/faq">
                                                    FAQ
                                                </Link>
                                            </li>
                                        </ul>
                                    </li>

                                    <li className="s-footer-nav__list">
                                        <Link to="/" className="s-footer-nav__list-item pointerDisabled">
                                            company
                                            <span>
                                                <img
                                                    className="s-footer-nav__list-icon"
                                                    src={SpayArrow}
                                                    alt="arrow-btn"
                                                />
                                            </span>
                                        </Link>
                                        <ul className="s-footer-nav__submenu  s-footer-nav__submenu--mod">
                                            <li
                                                className="s-footer-nav__submenu-list"
                                                onClick={() => this.handleScrollToTop()}>
                                                <Link className="s-footer-nav__submenu-list-item" to="/about">
                                                    About
                                                </Link>
                                            </li>
                                            {/* <li className="s-footer-nav__submenu-list">
                                                <Link className="s-footer-nav__submenu-list-item" to="/">
                                                    Blog
                                                </Link>
                                            </li> */}
                                            <li
                                                className="s-footer-nav__submenu-list"
                                                onClick={() => this.handleScrollToTop()}>
                                                <Link className="s-footer-nav__submenu-list-item" to="/">
                                                    Careers
                                                </Link>
                                            </li>
                                        </ul>
                                    </li>
                                </ul>
                            </nav>

                            {/*Mobile Navigation Structure | End Here */}

                            {/*Desktop Navigation Structure | Start Here */}

                            <nav className="s-footer-nav__container  s-footer-nav__container--desktop">
                                <ul className="s-footer-nav__list-wrap  s-footer-nav__list-wrap--mod">
                                    <li
                                        className="s-footer-nav__list"
                                        style={{ cursor: 'pointer' }}
                                        onClick={() => this.handleScrollToTop()}>
                                        <Link className="s-footer-nav__list-item" to="/">
                                            why spay
                                        </Link>
                                    </li>
                                    <li className="s-footer-nav__list" onClick={() => this.handleScrollToTop()}>
                                        <Link className="s-footer-nav__list-item" to="/Spay-Pricing">
                                            pricing
                                        </Link>
                                    </li>
                                    <li className="s-footer-nav__list" onClick={() => this.handleScrollToTop()}>
                                        <Link className="s-footer-nav__list-item" to="/">
                                            customers
                                        </Link>
                                    </li>
                                </ul>

                                <ul className="s-footer-nav__list-wrap  s-footer-nav__list-wrap--mod">
                                    <li className="s-footer-nav__list">
                                        <Link to="/" className="s-footer-nav__list-item  pointerDisabled">
                                            developers
                                            <span>
                                                <img
                                                    className="s-footer-nav__list-icon"
                                                    src={SpayArrow}
                                                    alt="arrow-btn"
                                                />
                                            </span>
                                        </Link>
                                        <ul className="s-footer-nav__submenu  s-footer-nav__submenu--mod">
                                            <li className="s-footer-nav__submenu-list">
                                                <a
                                                    href="https://spay.readme.io/docs"
                                                    className="s-footer-nav__submenu-list-item">
                                                    Documentation
                                                </a>
                                            </li>
                                            <li
                                                className="s-footer-nav__submenu-list"
                                                onClick={() => this.handleScrollToTop()}>
                                                <a
                                                    className="s-footer-nav__submenu-list-item"
                                                    href="https://join.slack.com/t/spaydev/shared_invite/zt-1q8o2pxyb-I6OFixebedcXlVNFTEuksg"
                                                    rel="noreferrer">
                                                    Developer Community
                                                </a>
                                            </li>
                                        </ul>
                                    </li>

                                    <li className="s-footer-nav__list">
                                        <Link to="/" className="s-footer-nav__list-item  pointerDisabled">
                                            support
                                            <span>
                                                <img
                                                    className="s-footer-nav__list-icon"
                                                    src={SpayArrow}
                                                    alt="arrow-btn"
                                                />
                                            </span>
                                        </Link>
                                        <ul className="s-footer-nav__submenu  s-footer-nav__submenu--mod">
                                            <li
                                                className="s-footer-nav__submenu-list"
                                                onClick={() => this.handleScrollToTop()}>
                                                <Link className="s-footer-nav__submenu-list-item" to="/spay-help">
                                                    SPay Help
                                                </Link>
                                            </li>
                                            <li className="s-footer-nav__submenu-list">
                                                <a
                                                    className="s-footer-nav__submenu-list-item"
                                                    href="/terms-and-conditions">
                                                    Terms & Conditions
                                                </a>
                                            </li>
                                            {/* <li className="s-footer-nav__submenu-list">
                                                <Link className="s-footer-nav__submenu-list-item" to="/">
                                                    Community
                                                </Link>
                                            </li> */}
                                            <li
                                                className="s-footer-nav__submenu-list"
                                                onClick={() => this.handleScrollToTop()}>
                                                <Link className="s-footer-nav__submenu-list-item" to="/faq">
                                                    FAQ
                                                </Link>
                                            </li>
                                        </ul>
                                    </li>

                                    <li className="s-footer-nav__list">
                                        <Link
                                            to="/"
                                            className="i-nav dropdown  s-footer-nav__list-item  pointerDisabled">
                                            company
                                            <span>
                                                <img
                                                    className="s-footer-nav__list-icon"
                                                    src={SpayArrow}
                                                    alt="arrow-btn"
                                                />
                                            </span>
                                        </Link>
                                        <ul className="s-footer-nav__submenu  s-footer-nav__submenu--mod">
                                            <li
                                                className="s-footer-nav__submenu-list"
                                                onClick={() => this.handleScrollToTop()}>
                                                <Link className="s-footer-nav__submenu-list-item" to="/about">
                                                    About
                                                </Link>
                                            </li>
                                            {/* <li className="s-footer-nav__submenu-list">
                                                <Link className="s-footer-nav__submenu-list-item" to="/">
                                                    Blog
                                                </Link>
                                            </li> */}
                                            <li
                                                className="s-footer-nav__submenu-list"
                                                onClick={() => this.handleScrollToTop()}>
                                                <Link className="s-footer-nav__submenu-list-item" to="/">
                                                    Careers
                                                </Link>
                                            </li>
                                        </ul>
                                    </li>
                                </ul>
                            </nav>

                            {/*Desktop Navigation Structure | End Here */}

                            <div className="s-footer-nav__contact">
                                <div className="s-footer-nav__contact-wrap">
                                    <div className="s-footer-nav__contact-head">
                                        <h4 className="s-footer-nav__contact-header">Get in Touch</h4>
                                        <ul className="s-footer-nav__contact-title-wrap">
                                            <li className="s-footer-nav__contact-title">
                                                Feel free to get in touch with us via email
                                            </li>
                                        </ul>
                                    </div>

                                    <div className="s-footer-nav__contact-social-links">
                                        <ul className="s-footer-nav__contact-email-wrap">
                                            <li className="s-footer-nav__contact-email">
                                                <Link
                                                    className="s-footer-nav__contact-email-direct"
                                                    to="mailto:someone@example.com">
                                                    help@spaybusiness.com
                                                </Link>
                                            </li>
                                        </ul>

                                        <ul className="s-footer-nav__contact-icons">
                                            <li className="s-footer-nav__contact-icons-list">
                                                <Link to="/">
                                                    <img
                                                        className="[ s-footer-nav__contact-ico ]"
                                                        src={SpayFacebook_icon}
                                                        alt="facebook"
                                                    />
                                                </Link>
                                            </li>
                                            <li className="s-footer-nav__contact-icons-list">
                                                <Link to="/">
                                                    <img
                                                        className="[ s-footer-nav__contact-ico ]"
                                                        src={SpayTwitter_icon}
                                                        alt="twitter"
                                                    />
                                                </Link>
                                            </li>
                                            <li className="s-footer-nav__contact-icons-list">
                                                <Link to="/">
                                                    <img
                                                        className="s-footer-nav__contact-ico"
                                                        src={SpayInstagram_icon}
                                                        alt="instagram"
                                                    />
                                                </Link>
                                            </li>
                                            <li className="s-footer-nav__contact-icons-list">
                                                <Link to="/">
                                                    <img
                                                        className="s-footer-nav__contact-ico"
                                                        src={SpayLinkedin_icon}
                                                        alt="linkedin"
                                                    />
                                                </Link>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                                <div className="spay-copyright">
                                    <Link className="spay-copyright__copy" to="/">
                                        &copy; SPay all rights reserved. <br />
                                        2019 - {new Date().getFullYear()} SPay,
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </footer>

            // Footer Content | End Here
        );
    }
}

export default SpayFooter;
